var map = {
	"./built-with-verse": [
		820,
		0
	],
	"./built-with-verse.svg": [
		820,
		0
	],
	"./loader-background-circle.png": [
		1454,
		10
	],
	"./loader_2.png": [
		1455,
		11
	],
	"./noise.png": [
		1456,
		12
	],
	"./the-british-impact-monogram": [
		821,
		1
	],
	"./the-british-impact-monogram.svg": [
		821,
		1
	],
	"./the-british-impact-story-cover": [
		822,
		2
	],
	"./the-british-impact-story-cover.svg": [
		822,
		2
	],
	"./verse-logo": [
		823,
		3
	],
	"./verse-logo-trimmed": [
		425
	],
	"./verse-logo-trimmed.svg": [
		425
	],
	"./verse-logo.svg": [
		823,
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1218;
module.exports = webpackAsyncContext;